import React from 'react';
import Store from '../_utils/tools/store';
import classNames from 'classnames';

// -----------------------------------------------------------
//  SiteLogo
// -----------------------------------------------------------
const SiteLogo = ({ onClick, className }) => (
  <a
    className={classNames('logo', className)}
    role="button"
    aria-label={`Back to ${Store.name} Photo Home page`}
    href="/"
    onClick={onClick}
  />
);

export default SiteLogo;
